module.exports = __webpack_public_path__ + "static/media/om_eyebrowshape_upward_vector.2e16e9cb.svg";